import React, { useEffect } from 'react';
import WebSocket from '@services/WebSocket';
import { connect } from 'react-redux';
import { USER_ROLE } from '@config/app';
import { getCookie } from '@common/utils/cookie';
import { setTeam } from '@resources/Team/actions';
import { addClue, addClues } from '@resources/Clue/actions';
import { addPuzzle, addPuzzles } from '@resources/Puzzle/actions';
import { setSocket } from '@resources/Socket/actions';
import {
  addMember,
  removeMember,
  updateMember,
} from '@resources/Member/actions';
import { setUser } from '@resources/User/actions';
import { doAction } from '@resources/Action/actions';
import { notification } from 'antd';
import {
  updateSolve,
  fetchSolves,
  addSolve,
  fetchSolvesByChannel,
} from '@resources/Solve/actions';
import { setState } from '@resources/State/actions';
import { addStory, fetchStories } from '@resources/Story/actions';
import { addHelp, fetchHelps } from '@resources/Help/actions';
import { setEnd, fetchEnd } from '@resources/End/actions';

const Player = ({
  match,
  user,
  history,
  addMember,
  updateSolve,
  removeMember,
  setTeam,
  doAction,
  updateMember,
  setSocket,
  addHelp,
  setState,
  addSolve,
  fetchSolvesByChannel,
}) => {
  const { params } = match || {};
  const { gameId, channelId } = params || {};
  // const solvedPuzzles = getCookie('solved')
  // 	? JSON.parse(getCookie('solved'))
  // 	: [];

  useEffect(() => {
    const fetchData = async () => {
      // You can await here

      setTeam(channelId);
      // ...
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!getCookie('CNVuser')) {
      history.push(`/carnival/${gameId}/${channelId}/user`);
    }

    if (channelId && getCookie('CNVuser')) {
      const u = JSON.parse(getCookie('CNVuser'));
      let uid = null;
      let chan = null;
      if (u && u.name) {
        const { pusher, channel } = WebSocket({
          game: gameId,
          channel: 'universal',
          name: u.name,
          role: USER_ROLE.PLAYER,
          onSubscribed: (member) => {
            uid = member.me.id;
            chan = channel;
            doAction({
              game: gameId,
              event: 'log',
              channel: chan,
              message: {
                id: uid,
                name: u.name,
                channel: channelId,
                location: 'lobby',
                message: 'has joined the game',
                game: gameId,
              },
            });
            for (var id in member.members) {
              const m = member.members[id];
              if (m.role === USER_ROLE.PLAYER) {
                if (id === uid) {
                  addMember({ id, name: u.name });
                } else {
                  addMember({ id, name: m.name });
                }
              }
            }
            setSocket({ id: uid, channel });
          },
          onMemberAdded: (member) => {
            if (member.info.role === USER_ROLE.PLAYER) {
              doAction({
                game: gameId,
                event: 'member',
                channel,
                message: { id: uid, name: u.name, game: gameId },
              });
              addMember({
                id: member.id,
                name: member.info.name,
              });
            }
          },
          onMemberRemoved: (member) => {
            if (member.info.role === USER_ROLE.PLAYER) {
              removeMember(member);
            }
          },
          events: [
            {
              title: 'member',
              callback: (data) => {
                // console.log('SOCKET MEMBER', data);
                updateMember(data);
              },
            },
            {
              title: 'notification',
              callback: (notif) => {
                // console.log('SOCKET NOTIFICATION', notif);
                notification[notif.type]({
                  message: notif.title,
                  description: notif.description,
                });
              },
            },
            {
              title: 'solved',
              callback: async (solve) => {
                // console.log('SOCKET SOLVED', solve);
                // const solved = getCookie('solved')
                //   ? JSON.parse(getCookie('solved'))
                //   : [];
                // setCookie(
                //   'solved',
                //   JSON.stringify(
                //     solved
                //       ? solved.filter((puzz) => puzz === solve).length > 0
                //         ? solved
                //         : [...solved, solve]
                //       : [solve]
                //   )
                // );

                if (solve.game === gameId && solve.channel === channelId) {
                  // updateSolve(solve);

                  await fetchSolvesByChannel(gameId, channelId);
                  if (solve.act === 'create') {
                    notification['success']({
                      message: 'Task Completed',
                      description: `Your team's submission for a task has been verified`,
                    });
                  }
                }
              },
            },
            {
              title: 'state',
              callback: (state) => {
                // console.log('SOCKET HELP', help);
                setState(state);
              },
            },
            {
              title: 'help',
              callback: (help) => {
                // console.log('SOCKET HELP', help);
                addHelp(help.puzzle);
              },
            },
          ],
        });

        window.addEventListener('beforeunload', () => {
          doAction({
            game: gameId,
            event: 'log',
            channel,
            message: {
              id: uid,
              name: u.name,
              channel: channelId,
              location: 'lobby',
              message: 'has left the game',

              game: gameId,
            },
          });
          pusher.unsubscribe(channel);
        });
      }
    }
  }, [channelId, user, history]);

  return <div></div>;
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
    clues: state.clues,
    helps: state.helps,
    solves: state.solves,
  };
};

export default connect(mapStateToProps, {
  addMember,
  addPuzzle,
  addPuzzles,
  removeMember,
  updateMember,
  setTeam,
  setUser,
  doAction,
  setSocket,
  addClue,
  addClues,
  fetchSolves,
  fetchHelps,
  updateSolve,
  addHelp,
  setEnd,
  fetchEnd,
  addStory,
  fetchStories,
  setState,
  addSolve,
  fetchSolvesByChannel,
})(Player);
